import { render, staticRenderFns } from "./WorkingHoursEditor.vue?vue&type=template&id=b831bafe&scoped=true"
import script from "./WorkingHoursEditor.vue?vue&type=script&lang=js"
export * from "./WorkingHoursEditor.vue?vue&type=script&lang=js"
import style0 from "./WorkingHoursEditor.vue?vue&type=style&index=0&id=b831bafe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b831bafe",
  null
  
)

export default component.exports